module.exports = __webpack_public_path__ + "static/media/headerLogo.0d9c7926.png";